import {
	call, delay, put, race, takeEvery,
} from "redux-saga/effects";
import { objectToQueryString } from "helpers/queryString";
import Env from "../../../consts/env";

import {
	ActionsSearchBrands,
	failureSearchBrands, loadGetSearchBrands, loadSearchBrandsSuccess,
} from "./actions";

function* loadDataSearchBrands(params = {}) {

	try {

		yield put(loadGetSearchBrands());
		const queryParams = objectToQueryString({
			next_id: params.payload.next_id,
			page: !params.payload.next_id ? params.payload.page : 1,
			limit: params.payload.limit,
			type: params.payload.type,
			sort: params.payload.sort,
			keyword: params.payload.keyword,
		});
		const endpoint = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api-new/searchBrands?${queryParams}`;

		const headers = { ...Env.HEADERS, page: params.payload.page };
		const method = "GET";
		const options = { headers, method };

		const { timeout, response } = yield race({
			timeout: delay(30000),
			response: call(fetch, endpoint, options),
		});

		if (timeout) {

			yield put(failureSearchBrands(yield "Error Timeout..."));

		} else {

			const dataSearchBrands = yield response.json();

			if (response.status !== 200) {

				yield put(failureSearchBrands(yield response.statusText));

			} else {

				yield put(loadSearchBrandsSuccess(yield dataSearchBrands));

			}

		}

	} catch (err) {

		yield put(failureSearchBrands(err));

	}

}

export default function* rootSaga() {

	yield takeEvery(ActionsSearchBrands.GET_SEARCH_BRANDS, loadDataSearchBrands);

}
